<template>
  <div>
    <!--<div class="text-center my-3">-->
    <!--<b-btn v-b-tooltip.hover title="I'm a tooltip!">Hover Me</b-btn>-->
    <!--</div>-->
    <form role="form">
      <div class="overlay" v-if="isClotureValide()">
        <div class="row">
          <div class="col-md-12" style="padding:5%;text-align: center; font-size: 16px; border:1px solid black;background-color:#FFF;width: 90%;margin: 5%;">
            <p>Ce récapitulatif est au statut <strong>validé/cloturé ou en attente de payement</strong> . Toute modification peut entraîner une modification comptable.
              <br>Souhaitez-vous modifier ce récapitulatif ?</p>
            <button type="button"
                    class="btn btn-md btn-primary btn-flat margin align-center"
                    style="margin-top: 0;margin-bottom: 0;"
                    @click="acceptToModifyRecap=true"
            >
              Modifier ce récapitulatif
            </button>
          </div>
        </div>

      </div>

      <b-alert
        :variant="getRecap.order.order_payed ? 'success':'warning'"
        class="col-md-12"
        v-if="getRecap.order"
        show>
        <p class="pull-left">
          Attention, ce récapitulatif est lié au bon de commande
          <router-link
            :to="{ name: 'Liste_commandes_myabft', params: { order_id: getRecap.order.id }}">
            Bon de commande n°{{ getRecap.order.id  | idFormat }}
          </router-link>
          <br>
          Ce bon de commande est
          <span v-if="getRecap.order.order_payed"><strong>Payé</strong></span>
          <span v-if="!getRecap.order.order_payed"><strong>Non-payé</strong></span>
          et au statut <strong>{{ getRecap.order.statut.statut }}</strong>
        </p>
      </b-alert>

      <div class="row">
        <div class="col-md-6">

          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Données du récapitulatif</h3>
<!--              <button type="button"-->
<!--                      class="btn btn-xs btn-danger btn-flat margin pull-right"-->
<!--                      style="margin-top: 0;margin-bottom: 0;"-->
<!--                      @click="supprimerRecap()"-->
<!--              >-->
<!--                Supprimer le récapitulatif-->
<!--              </button>-->
            </div>

            <div class="box-body">
              <div :class="{'col-md-6': getRecap.order,'col-md-12': !getRecap.order}">
                <div class="form-group">
                  <label for="statut">Club</label>

                  <router-link :to="{ name: 'Club', params: { club_id: getRecap.club.id }}">
                    <h4><strong>{{ getRecap.club.nameFormat }}</strong></h4>
                  </router-link>
                </div>
              </div>

              <div class="col-md-6" v-if="getRecap.order">
                <div class="form-group">
                  <label for="statut">Bon de commande lié <i class="fa fa-warning"></i></label>
                  <router-link
                    :to="{ name: 'Liste_commandes_myabft', params: { order_id: getRecap.order.id }}">
                    <h4>
                      <strong>Bon de commande n°{{ getRecap.order.id  | idFormat }} </strong>
                    </h4>
                  </router-link>
                  <h4>
                    <strong>
                      <span v-if="getRecap.order.order_payed" class="text-green">Payé</span>
                      <span v-if="!getRecap.order.order_payed" class="text-red">Non-payé</span>
                    </strong>
                  </h4>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for="statut">Statut actuel</label>
                  <select id="statut" class="form-control" name="recap[statut]"
                          v-model="getRecap.statut.id">
                    <option
                      v-for="statut in getStatusRecap"
                      :value="statut.id"
                    > {{ statut.type }}
                    </option>
                  </select>
                  <!--<span class="help-block">Help block with error</span>-->
                </div>
                <div class="form-group" v-if="getRecap.order">
                  <div class="form-group">
                    <label for="stavestatutorder">
                      <input type="checkbox"
                             id="stavestatutorder"
                             v-model="saveStatusOrder">
                      Appliquer le même statut au bon de commande
                    </label>
                  </div>
                  <!--<span class="help-block">Help block with error</span>-->
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group"
                     :class="{'has-error': errors.has('recap[date]') }">
                  <label>Date d'entrée du récapitulatif</label>
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar"></i>
                    </div>
                    <masked-input type="text"
                                  disabled
                                  v-model="getRecap.date"
                                  v-validate="'required|date_format:DD/MM/YYYY'"
                                  :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
                                  :guide="true"
                                  :keepCharPositions="true"
                                  :showMask="true"
                                  name="recap[date]"
                                  class="form-control pull-right datepicker"
                                  id="datepicker2">
                    </masked-input>
                  </div>
                  <span v-show="errors.has('recap[date]')"
                        class="help-block">Date incorrecte</span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Numéro du document comptable</label>

                  <input type="text" class="form-control"
                         id="numero_comptable" name="numero_comptable" disabled v-model="getRecap.numero_comptable">
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group"
                     :class="{'has-error': errors.has('recap[comment]') }">
                  <label for="nom">Commentaire</label>
                  <textarea type="text" class="form-control" id="nom" name="recap[comment]"
                            rows="5"
                            v-validate="'max:255'"
                            placeholder="Commentaire(s) éventuel(s)"
                            v-model="getRecap.comment">{{getRecap.comment}}</textarea>
                  <span v-show="errors.has('recap[comment]')" class="help-block">Le commentaire doit comporter moins de 255 caractères</span>
                </div>
              </div>
            </div>
          </div>

          <div class="box box-primary" v-if="this.getTextesRecap">
            <div class="box-header with-border">
              <h3 class="box-title">Mails à envoyer</h3>
            </div>
            <div class="box-body">
              <div class="overlay"
                   v-if="this.btnsSendMailsBusy"
              >
                <i class="fa fa-refresh fa-spin"></i>
              </div>

              <div class="col-md-12 margin ">
                <template v-if="getRecap.order && !getRecap.order.order_payed">
                  <label for="nom">Mail aux correspondants - BON DE COMMANDE NON-PAYE</label>
                  <p>
                    Vous ne pouvez envoyer un mail de confirmation d'envoi. <br>
                    Le bon de commande doit donc être réglé pour confirmer l'envoi des licences.
                  </p>
                </template>

                <template v-if="getRecap.order && getRecap.order.order_payed">
                  <label for="nom">Mail aux correspondants</label>
                  <div class="input-group">
                  <span class="input-group-btn">
                      <a type="button"
                         @click="sendMail('order_paye')"
                         class="btn btn-primary btn-flat">
                        <template>Envoyer la CONFIRMATION d'envoi des licences et passer le statut du bon de commande en "Livré"</template>
                      </a>
                    </span>
                  </div>
                </template>


                <template v-if="!getRecap.order">
                  <label for="nom">Si PAYE: Mail aux correspondants</label>
                  <div class="input-group">
                  <span class="input-group-btn">
                      <a type="button"
                         @click="sendMail('recap_paye')"
                         class="btn btn-primary btn-flat">
                        <template v-if="!getRecap.order">Envoyer la CONFIRMATION d'envoi des licences</template>
                        <!--                        <template v-if="getRecap.order">Envoyer la CONFIRMATION d'envoi des licences et mettre à jour le statut du bon de commande</template>-->
                      </a>
                    </span>
                  </div>
                </template>
              </div>

              <div class="col-md-12 margin">

                <template v-if="getRecap.order && !getRecap.order.order_payed">
                  <label for="nom">Mail de non-payement - BON DE COMMANDE NON-PAYE</label>
                  <p>
                    Ce récapitulatif est lié à un bon de commande. <br>
                    Veuillez envoyer le mail de rappel de payement depuis la page du
                    <router-link
                      :to="{ name: 'Liste_commandes_myabft', params: { order_id: getRecap.order.id }}">
                      bon de commande n°{{ getRecap.order.id  | idFormat }}
                    </router-link>
                  </p>
                </template>

                <template v-if="!getRecap.order">
                  <label for="nom">Si NON-PAYE: Mail aux correspondants</label>
                  <div class="input-group">
                    <span class="input-group-btn">
                                      <a type="button"
                                         @click="sendMail('recap_non_paye')"
                                         class="btn btn-primary btn-flat">Envoyer une DEMANDE DE PAYEMENT du récapitulatif</a>
                                    </span>
                  </div>
                </template>

              </div>

              <div class="col-md-12 margin">
                <label for="nom">Si PAYE: Mail aux membres</label>
                <div class="input-group">
                  <input type="text" class="form-control" @focus="$event.target.select()"
                         :value="getTextesRecap.PayeMembres.body.trim()">
                  <span class="input-group-btn">
                                      <a type="button"
                                         @click="copyToClipboard(getTextesRecap.PayeMembres.body.trim())"
                                         :href="constructMail('PayeMembres')"
                                         class="btn btn-primary btn-flat">Envoyer un mail à tous les membres</a>
                                    </span>
                </div>
              </div>

            </div>
          </div>

        </div>

        <div class="col-md-6">
          <div class="box box-primary"
               v-if="getRecap.id && getRecap.licences && getRecap.licences.length > 0">
            <div class="overlay" v-if="loadingSecretariatBox">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <div class="box-header with-border">
              <h3 class="box-title">Secrétariat</h3>
            </div>
            <div class="box-body">
              <button @click.prevent="exportCartesAnnuelles()" class="btn btn-primary">Imprimer les cartes
                annuelles
              </button>
              <button @click.prevent="exportEtiquettes()" class="btn btn-primary">Imprimer les
                étiquettes
              </button>
              <button @click.prevent="printRecap()" class="btn btn-primary">Imprimer le récapitulatif
              </button>
              <button class="btn btn-primary" @click.prevent="printEtiquetteEnvoi()">
                Imprimer l'étiquette d'envoi
              </button>
            </div>
          </div>
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Membres repris au sein du récapitulatif</h3>
            </div>
            <div class="box-body">
              <div class="overlay" v-if="isTableMembresLoading()">
                <i class="fa fa-refresh fa-spin"></i>
              </div>

              <div v-if="!isTableMembresLoading()">
                <b-table responsive bordered striped hover
                         :items="getRecap.licences"

                         :fields="columnsMembresInRecap"
                         :per-page="perPage"
                         :current-page="currentPage"
                         :empty-text="'Aucun résultat'"
                         :empty-filtered-text="'Aucun résultat'"
                         foot-clone
                         show-empty
                >
                  <template slot="actions" slot-scope="row">
                    <router-link
                      class="btn btn-default padding2"
                      :to="{ name: 'Member', params: { member_id: row.item.membre.id }}">
                      <i class="glyphicon glyphicon-pencil"></i>
                    </router-link>
                    <a href="#" @click.prevent="removeLicence(row.item.id)"
                       class="btn btn-default padding2">
                      <i class="glyphicon glyphicon-remove"></i>
                    </a>
                  </template>
                  <template slot="id" slot-scope="data">
                    {{ data.value | idFormat }}
                  </template>
                  <template slot="membre.fullName" slot-scope="row">
                    <router-link
                      :to="{ name: 'Member', params: { member_id: row.item.membre.id }}">
                      {{ row.item.membre.fullName }}
                    </router-link>
                  </template>
                  <template slot="type_rel" slot-scope="data">
                    {{ data.value.type }}
                  </template>
                  <template slot="montant" slot-scope="data">
                    {{ data.value }}€
                  </template>
                  <!--<template slot="FOOT_id" slot-scope="foo"></template>-->
                  <!--<template slot="FOOT_nom" slot-scope="foo"></template>-->
                  <!--<template slot="FOOT_type_rel" slot-scope="foo"></template>-->
                  <template slot="FOOT_montant" slot-scope="foo">
                    <strong>{{ getRecap.total }}€</strong>
                  </template>
                  <template slot="FOOT_actions" slot-scope="foo"></template>
                </b-table>
                <b-pagination size="md"
                              :total-rows="getRecap.licences.length"
                              v-model="currentPage"
                              :per-page="perPage">
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="nav-tabs-custom">
            <ul class="nav nav-tabs">
              <li class="active">
                <a href="#tab_0" data-toggle="tab" aria-expanded="true">Logs</a>
              </li>
              <li class="">
                <a href="#tab_1" data-toggle="tab" aria-expanded="true">Membres non-liés</a>
              </li>
              <li class="">
                <a href="#tab_2" data-toggle="tab" aria-expanded="false">Membres {{ currentYear() }} de ce club</a>
              </li>
            </ul>

            <div class="tab-content">
              <div class="tab-pane active" id="tab_0">
                <b-table
                  id="tableLogsRecap"
                  responsive bordered striped hover
                  :items="getRecap.log"
                  :fields="logsOptions.columnsLog"
                  :current-page="logsOptions.pagination_meta.current_page"
                  :per-page="logsOptions.pagination_meta.per_page"
                  :empty-text="'Aucun résultat'"
                  :empty-filtered-text="'Aucun résultat'"
                  foot-clone
                  show-empty
                >
                  <template slot="created_at" slot-scope="row">
                    {{ row.item.date }}
                  </template>
                  <span slot="fullDescription" slot-scope="data" v-html="data.value"> </span>
                </b-table>
                <b-pagination size="md"
                              :total-rows="getRecap.log.length"
                              v-model="logsOptions.pagination_meta.current_page"
                              :per-page="logsOptions.pagination_meta.per_page">
                </b-pagination>
              </div>

              <div class="tab-pane " id="tab_1">
                <div class="overlay" v-if="loadingWhitoutRecap">
                  <i class="fa fa-refresh fa-spin"></i>
                </div>
                <div v-if="!loadingWhitoutRecap">
                  <b-table responsive bordered striped hover
                           :items="licencesWithoutRecap"
                           :fields="columnsLicencesWithoutRecap"
                           :per-page="perPage2"
                           :current-page="currentPage2"
                           :empty-text="'Aucun résultat'"
                           :empty-filtered-text="'Aucun résultat'"
                           foot-clone
                           show-empty
                  >
                    <template slot="actions" slot-scope="row">
                      <router-link
                        class="btn btn-default padding2"
                        :to="{ name: 'Member', params: { member_id: row.item.membre.id }}">
                        <i class="glyphicon glyphicon-pencil"></i>
                      </router-link>
                      <!--<a href="#" @click.prevent="removeLicence(row.item.id)"-->
                      <!--alt="Libérer cette licence de son récapitulatif actuel"-->
                      <!--class="btn btn-default padding2">-->
                      <!--<i class="glyphicon glyphicon-remove"></i>-->
                      <!--</a>-->
                      <b-btn v-b-tooltip.hover
                             title="Ajouter cette licence au récapitulatif"
                             @click.prevent="addLicence(row.item.id)"
                             class="btn btn-default padding2">
                        <i class="glyphicon glyphicon glyphicon-copy"></i>
                      </b-btn>
                    </template>
                    <template slot="id" slot-scope="data">
                      {{ data.value | idFormat }}
                    </template>
                    <template slot="nom" slot-scope="data">
                      <router-link
                        :to="{ name: 'Member', params: { member_id: data.item.membre.id }}">
                        {{ data.item.membre.fullName }}
                      </router-link>
                    </template>
                    <template slot="club" slot-scope="data">
                      <router-link
                        :to="{ name: 'Club', params: { club_id: data.item.club.id }}">
                        {{ data.item.club.nameFormat }}
                      </router-link>

                    </template>
                    <template slot="type_rel" slot-scope="data">
                      {{ data.value.type }}
                    </template>

                  </b-table>
                  <b-pagination size="md"
                                :total-rows="licencesWithoutRecap.length"
                                v-model="currentPage2"
                                :per-page="perPage2">
                  </b-pagination>
                </div>
              </div>

              <div class="tab-pane" id="tab_2">
                <div class="overlay" v-if="loadingCurrentYear">
                  <i class="fa fa-refresh fa-spin"></i>
                </div>
                <div v-if="!loadingCurrentYear">
                  <b-table responsive bordered striped hover
                           :items="licencesCurrentYear"

                           :fields="columnsLicencesWithoutRecap"
                           :per-page="perPage3"
                           :current-page="currentPage3"
                           :empty-text="'Aucun résultat'"
                           :empty-filtered-text="'Aucun résultat'"
                           foot-clone
                           show-empty
                  >
                    <template slot="actions" slot-scope="row">
                      <router-link
                        class="btn btn-default padding2"
                        :to="{ name: 'Member', params: { member_id: row.item.membre.id }}">
                        <i class="glyphicon glyphicon-pencil"></i>
                      </router-link>
                      <a href="#" @click.prevent="removeLicence(row.item.id)"
                         alt="Libérer cette licence de son récapitulatif actuel"
                         class="btn btn-default padding2">
                        <i class="glyphicon glyphicon-remove"></i>
                      </a>
                      <b-btn v-b-tooltip.hover
                             title="Ajouter cette licence au récapitulatif"
                             @click.prevent="addLicence(row.item.id)"
                             class="btn btn-default padding2">
                        <i class="glyphicon glyphicon glyphicon-copy"></i>
                      </b-btn>
                    </template>
                    <template slot="id" slot-scope="data">
                      {{ data.value | idFormat }}
                    </template>
                    <template slot="nom" slot-scope="data">
                      <router-link
                        :to="{ name: 'Member', params: { member_id: data.item.membre.id }}">
                        {{ data.item.membre.fullName }}
                      </router-link>
                    </template>
                    <template slot="club" slot-scope="data">
                      <router-link
                        :to="{ name: 'Club', params: { club_id: data.item.club.id }}">
                        {{ data.item.club.nameFormat }}
                      </router-link>

                    </template>
                    <template slot="type_rel" slot-scope="data">
                      {{ data.value.type }} -
                      <router-link
                        v-if="data.item.id_recapitulatif!=0"
                        :to="{ name: 'Recap', params: { recap_id: data.item.id_recapitulatif }}">
                        Déjà lié au Récap {{ data.item.id_recapitulatif }}
                      </router-link>

                      <span v-if="data.item.id_recapitulatif==0">
                                            Non-lié
                                        </span>

                    </template>

                  </b-table>
                  <b-pagination size="md"
                                :total-rows="licencesCurrentYear.length"
                                v-model="currentPage3"
                                :per-page="perPage3">
                  </b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="box ">
            <div class="overlay"
                 v-if="this.disabledBtn"
            >
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <div class="box-body">
            </div>
            <div class="box-footer">


              <button type="button"
                      class="btn btn-lg btn-primary btn-flat margin pull-right"
                      :disabled="errors.count()!=0 || this.disabledBtn || this.loadingInputs.length>0"
                      @click="sendForm()"
              >
                Enregistrer les modifications
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {ErrorBag} from 'vee-validate';
import vSelect from '../../Communs/vSelect/index'

var $ = require('jquery');
var variables = require('../../../assets/js/variables')
var _ = require('underscore')
var moment = require('moment')
var FileSaver = require('file-saver');

export default {
  props: {
    loadingTableMembres: {
      required: true,
      'default': false
    },
  },
  data() {
    return {
      acceptToModifyRecap: false,
      loadingInputs: [],
      disabledBtn: false,
      btnsSendMailsBusy: false,
      resize: false,
      activeTab: "default",
      activeDojang: null,
      dataTableLogClub: null,
      dataTableFilesClub: null,
      redraw: "",
      delete_licences_when_delete_recap: false,
      loadingSecretariatBox: false,
      loadingWhitoutRecap: false,
      loadingCurrentYear: false,
      licencesWithoutRecap: [],
      licencesCurrentYear: [],
      currentPage: 1,
      perPage: 20,
      currentPage2: 1,
      perPage2: 20,
      currentPage3: 1,
      perPage3: 20,
      sortByMembresInRecap: 'id',
      sortDescMembresInRecap: false,
      saveStatusOrder: true,
      columnsMembresInRecap: [
        {
          label: 'Num. Lic.',
          key: 'id',
          sortable: true,
        },
        {
          label: 'Nom',
          key: 'membre.fullName',
          sortable: true,
        },
        {
          label: 'Type',
          key: 'type_rel',
          sortable: true,
        },
        {
          label: 'Date début',
          key: 'date_debut',
          sortable: true,
        },
        {
          label: 'Date fin',
          key: 'date_fin',
          sortable: true,
        },
        {
          label: 'Montant',
          key: 'montant',
          sortable: true,
        },
        {
          label: 'Actions',
          key: 'actions',
        },
      ],
      columnsLicencesWithoutRecap: [
        {
          label: 'Num. Lic.',
          key: 'id',
          sortable: true,
        },
        {
          label: 'Club',
          key: 'club',
          sortable: true,
        },
        {
          label: 'Nom',
          key: 'nom',
          sortable: true,
        },
        {
          label: 'Type',
          key: 'type_rel',
          sortable: true,
        },
        {
          label: 'Actions',
          key: 'actions',
        },
      ],
      logsOptions: {
        columnsLog: [
          {
            label: 'Date',
            key: 'created_at',
            sortable: true,
          },
          {
            label: 'Action',
            key: 'fullDescription',
            sortable: false,
          },
          {
            label: 'Responsable',
            key: 'user',
            sortable: true,
          },
        ],
        pagination_meta: {
          current_page: 1,
          from: 1,
          last_page: 1,
          path: "",
          per_page: 40,
          to: 1,
          total: 1
        },
      },
    }
  },
  computed: {
    ...mapGetters({
      getRoute: 'getRoute',
      getStatusRecap: 'getStatusRecap',
      getTextesRecap: 'getTextesRecap',
      getRecap: 'getRecap'
    }),
  },
  mounted: function () {
    var these = this
  },
  created() {
    this.getTableLicencesWithoutRecap();
    this.getTableLicencesCurrentYear();

  },
  beforeRouteEnter(to, from, next) {
    this.getTableLicencesWithoutRecap();
    this.getTableLicencesCurrentYear();
    next()
  },
  watch: {},
  components: {
    vSelect,
  },
  methods: {
    ...mapActions({}),


    sortCompareAdvanced: function (a, b, key) {
      // debugger
      return this.$sortCompareAdvanced(a, b, key)
    },
    isClotureValide: function () {
      // debugger;
      return (this.getRecap.statut.meta == 'done' || this.getRecap.statut.meta == 'wait_pay') && !this.acceptToModifyRecap;
      // return this.getRecap.statut.meta=='done' && !this.acceptToModifyRecap;
    },
    currentYear: function () {
      return moment().year();
    },
    getTableLicencesWithoutRecap: function () {
      this.loadingWhitoutRecap = true;
      this.$http.get(this.getRoute('Secretariat.recapitulatif.getLicencesWithoutRecap')).then((response) => {
        this.licencesWithoutRecap = response.body
        this.loadingWhitoutRecap = false;
      }, (response) => {
      });
    },
    getTableLicencesCurrentYear: function () {
      this.loadingCurrentYear = true;
      this.$http.get(this.getRoute('Secretariat.recapitulatif.getLicencesCurrentYear') + this.getRecap.id_club)
        .then((response) => {
          this.licencesCurrentYear = response.body
          this.licencesCurrentYear.forEach(function (item, index) {
            item._rowVariant = item.id_recapitulatif == 0 ? 'danger' : '';
          });
          this.loadingCurrentYear = false;
        }, (response) => {
        });
    },
    isTableMembresLoading: function (force = false) {
      if (force)
        return true
      return this.loadingTableMembres;
    },

    printEtiquetteEnvoi: function () {
      let these = this;
      this.loadingSecretariatBox = true
      this.$http.post
      (
        this.getRoute('Secretariat.etiquetteIndividuelleClub'),
        JSON.stringify({id_club: this.getRecap.club.id, id_order: these.getRecap.order ? these.getRecap.order.id : null}),
        {responseType: 'blob'}
      ).then(function (response) {
        this.loadingSecretariatBox = false
        var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
        FileSaver.saveAs(blob, this.getRecap.club.id + "_etiquette.pdf");
        return response.blob();

      }, (response) => {
        these.$noty.error("Erreur dans la génération de l'étiquette")
        this.loadingSecretariatBox = false
      });
    },

    printRecap: function () {
      let these = this;
      if (!this.getRecap.id || !this.getRecap.licences || this.getRecap.licences.length <= 0)
        return;
      this.loadingSecretariatBox = true

      this.$http.post
      (
        this.getRoute('generateFacture'),
        JSON.stringify({"id_recap": these.getRecap.id, "add_listing_for_secretariat":true,id_order: these.getRecap.order ? these.getRecap.order.id : null}),
        {responseType: 'blob'}
      ).then(function (response) {
        this.loadingSecretariatBox = false
        var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
        FileSaver.saveAs(blob, "Recapitulatif_" + these.getRecap.id + ".pdf");
        return response.blob();
      }, (response) => {
        these.$noty.error("Erreur dans la génération du récap")
        this.loadingSecretariatBox = false
      });

    },
    exportEtiquettes: function () {
      if (!this.getRecap.id || !this.getRecap.licences || this.getRecap.licences.length <= 0)
        return;
      this.loadingSecretariatBox = true
      let these = this;
      this.$http.post
      (
        this.getRoute('Secretariat.etiquetteIndividuelleMembre'),
        JSON.stringify({"id_recap": these.getRecap.id}),
        {responseType: 'blob'}
      ).then(function (response) {
        this.loadingSecretariatBox = false
        var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
        FileSaver.saveAs(blob, these.getRecap.id + "_etiquettes.pdf");
        return response.blob();
      }, (response) => {
        these.$noty.error("Erreur dans la génération des étiquettes")
        this.loadingSecretariatBox = false
      });
    },
    exportCartesAnnuelles: function (qrCode = true) {
      if (!this.getRecap.id || !this.getRecap.licences || this.getRecap.licences.length <= 0)
        return;
      this.loadingSecretariatBox = true
      let these = this;
      let route = qrCode ? 'Secretariat.carteAnnuelleMembreQrcode' : 'Secretariat.carteAnnuelleMembre'

      this.$http.post
      (
        these.getRoute(route),
        JSON.stringify({"id_recap": these.getRecap.id}),
        {responseType: 'blob'}
      ).then(function (response) {
        these.loadingSecretariatBox = false
        var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
        FileSaver.saveAs(blob, these.getRecap.id + "_licences.pdf");
        return response.blob();
      }, (response) => {
        these.$noty.error("Erreur dans la génération des cartes")
        these.loadingSecretariatBox = false
      });
    },
    console: function (event) {
      console.log(event);
    },
    copyToClipboard: function (message) {
      let self = this;
      this.$copyText(message).then(function (e) {
        self.$noty.success("E-mail copié dans le presse-papier")

      }, function (e) {
        self.$noty.error("Erreur dans l'accès au presse-papier")
      })
    },
    sendMail: function (type) {
      // if (this.getRecap.order)
      //   return
      let self = this;
      this.btnsSendMailsBusy = true
      this.$http.post(this.getRoute('Secretariat.recapitulatif.sendMail'),
        {id_recap: this.getRecap.id, type_mail: type}).then(function (response) {
        self.$noty.success("Le mail a bien été envoyé.")
        this.btnsSendMailsBusy = false
        console.log(response.body)
        if (type == 'recap_non_paye') {
          self.getRecap.statut = response.body.statut
        }
      }, (response) => {
        this.btnsSendMailsBusy = false
        self.$noty.error("Erreur dans l'envoi du mail.")
      });
    },
    constructMail: function (key) {
      if (!this.getTextesRecap || !this.getTextesRecap[key].body)
        return '';
      return "mailto:" + (this.getTextesRecap[key].to ? this.getTextesRecap[key].to + '?' : "?") +
        "subject=" + this.getTextesRecap[key].subject +
        (this.getTextesRecap[key].cc ? "&cc=" + this.getTextesRecap[key].cc : "") +
        (this.getTextesRecap[key].cci ? "&bcc=" + this.getTextesRecap[key].cci : "")
    },
    constructForm: function () {
      return JSON.stringify({
        "statut": this.getRecap.statut.id,
        "date": this.getRecap.date,
        "comment": this.getRecap.comment,
        "saveStatusOrder": this.saveStatusOrder,
      })
    },
    formatDate: function (value, fmtIn = 'YYYY-MM-DD hh:mm:ss', fmtOut = 'DD/MM/YYYY HH:mm') {
      if (value == null) return ''
      return moment(value, fmtIn).format(fmtOut)
    },
    supprimerRecap: function () {
      let these = this
      let self = this
      this.$dialog.confirm('' +
        'Confirmez-vous la suppression du récapitulatif ?<br/><br/> ' +
        'L\'éventuel bon de commande lié devra également être reconverti en récapitulatif <br><br>' +
        'Tous les membres liés à ce récapitulatif seront libérés et devront être réaffectés à un autre récapitulatif. <br/><br/>' +
        'Toutefois, si vous souhaitez également supprimer les licences liées à ce récapitulatif, cochez la case ci-dessous<br/><br/> ' +
        '         <div class="checkbox">\n' +
        '                   <label for="delete_licences">\n' +
        '                     <input id="delete_licences" name="delete_licences" type="checkbox"\n' +
        '                            v-model="delete_licences_when_delete_recap">\n' +
        '                     <strong>Supprimer aussi les licences liées au récapitulatif</strong>' +
        '                   </label>\n' +
        '                 </div>'
        ,

        {
          html: true, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
          loader: true, // set to true if you want the dailog to show a loader after click on "proceed"
          reverse: false, // switch the button positions (left to right, and vise versa)
          okText: 'Supprimer le récapitulatif',
          cancelText: 'Annuler',
          animation: 'zoom', // Available: "zoom", "bounce", "fade"
          type: 'basic', // coming soon: 'soft', 'hard'
        })
        .then(function (dialog) {
          // console.log(document.getElementById('delete_licences').checked);
          setTimeout(() => {
            self.$http.post(self.getRoute('Secretariat.recapitulatif.delete'),
              {id_recap: self.getRecap.id, delete_licences_too: document.getElementById('delete_licences').checked})
              .then(function (response) {
                self.$noty.success("Récapitulatif supprimé")
                self.$router.push('/');
                dialog.close();
              }, (response) => {
                self.$noty.success("Erreur dans la suppression")
                dialog.close();
              });
          }, 1000);
        })
        .catch(function () {
        });
    },
    sendForm: function () {
      this.disabledBtn = true;
      let self = this;
      this.$http.put(this.getRoute('Secretariat.recapitulatif.update') + this.getRecap.id, this.constructForm()).then(function (response) {
        self.$noty.success("Le récapitulatif a bien été modifié")
        this.disabledBtn = false
      }, (response) => {
        self.$noty.error("Erreur dans la sauvegarde du récapitulatif")
        this.disabledBtn = false
      });
    },
    isInputLoading: function (input) {
      return _.indexOf(this.loadingInputs, input) >= 0 ? true : false
    },
    addToLoadingInputs: function (input) {
      this.loadingInputs.push(input)
    },
    removeFromLoadingInputs: function (input) {
      this.loadingInputs = _.without(this.loadingInputs, input)
    },
    removeLicence: function (id_licence) {
      let self = this
      this.isTableMembresLoading(true);
      this.$http.post(this.getRoute('Secretariat.recapitulatif.removeLicence'), {
        "id_licence": id_licence,
        "id_recap": this.getRecap.id
      }).then(function (response) {
        self.$noty.success("La licence a bien été supprimée de ce récapitulatif")
        self.$emit('onNeedRefreshRecap')
        self.getTableLicencesWithoutRecap()
        self.getTableLicencesCurrentYear()
        self.disabledBtn = false
        this.isTableMembresLoading(false);
      }, (response) => {
        self.$noty.error("Erreur dans la suppression de la licence")
        self.disabledBtn = false
        this.isTableMembresLoading(false);
      });
    },
    addLicence: function (id_licence) {
      let self = this
      this.isTableMembresLoading(true);
      this.$http.post(this.getRoute('Secretariat.recapitulatif.addLicence'), {
        "id_licence": id_licence,
        "id_recap": this.getRecap.id
      }).then(function (response) {
        self.$noty.success("La licence a bien été ajoutée à ce récapitulatif")
        self.$emit('onNeedRefreshRecap')
        self.getTableLicencesWithoutRecap()
        self.getTableLicencesCurrentYear()
        self.disabledBtn = false
        this.isTableMembresLoading(false);
      }, (response) => {
        self.$noty.error("Erreur dans l'ajout de la licence")
        self.disabledBtn = false
        this.isTableMembresLoading(false);
      });
    },
  }
  ,
  filters: {
    idFormat: function (value) {
      return new Intl.NumberFormat("de-DE").format(value)
    }
  }
  ,
}
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Recapitulatif/MainFormRecap.vue